import axios from "axios";
import { server } from "../api";

const buildStationPayload = (station = {}) => {
  const payload = {};
  if (station.name !== undefined) payload.name = station.name;
  if (station.device_id !== undefined) payload.device_id = station.device_id;
  if (station.category !== undefined) payload.category = station.category;
  // Positions are stored in meters
  if (station.position_x_meters !== undefined) {
    payload.position_x_meters = station.position_x_meters;
  }
  if (station.position_y_meters !== undefined) {
    payload.position_y_meters = station.position_y_meters;
  }
  if (station.radius_meters !== undefined) {
    payload.radius_meters = station.radius_meters;
  }
  if (station.allowed_personnel_ids !== undefined) {
    payload.allowed_personnel_ids = station.allowed_personnel_ids;
  }
  // tx_power may be null (explicit reset to default) or a number
  if (station.tx_power !== undefined) {
    payload.tx_power = station.tx_power;
  }
  return payload;
};

const normalizeStationArray = (stations = []) =>
  stations
    .filter((item) => item?.name && item?.device_id && item?.category)
    .map((item) => {
      const row = { name: item.name, device_id: item.device_id, category: item.category };
      if (item.tx_power !== undefined) row.tx_power = item.tx_power;
      return row;
    });

const IndoorPositioningStations = {
  GetStations: async (machineID) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/stations`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "獲取室內定位基站失敗",
          data: [],
        }
      );
    }
  },

  CreateStation: async (station) => {
    const machineID = station?.indoor_positioning_id;
    if (!machineID) {
      return { code: 400, message: "缺少室內定位機器 ID" };
    }
    const payload = buildStationPayload(station);
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/stations`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "新增室內定位基站失敗",
        }
      );
    }
  },

  UpdateStation: async (id, station) => {
    const payload = buildStationPayload(station);
    try {
      const response = await axios.put(
        `${server}indoor-positioning/stations/${id}`,
        payload,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "更新室內定位基站失敗",
        }
      );
    }
  },

  DeleteStation: async (id) => {
    try {
      const response = await axios.delete(
        `${server}indoor-positioning/stations/${id}`,
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "刪除室內定位基站失敗",
        }
      );
    }
  },

  BatchImportStations: async (stations, machineID) => {
    if (!machineID) {
      return { code: 400, message: "缺少室內定位機器 ID" };
    }
    const normalized = normalizeStationArray(stations);
    if (!normalized.length) {
      return { code: 400, message: "沒有有效的基站資料" };
    }
    try {
      const response = await axios.post(
        `${server}indoor-positioning/${machineID}/stations/import`,
        {
          stations: normalized,
        },
      );
      return response.data;
    } catch (error) {
      return (
        error.response?.data || {
          code: 500,
          message: "匯入室內定位基站失敗",
        }
      );
    }
  },
};

export default IndoorPositioningStations;
